/* eslint-disable import/first */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
// 主要解决 保证不同浏览器能够尽可能的拥有相同的显示效果
// 这里还需要下载 npm style-loader
import 'normalize.css'
import './style/index.scss'

// 按需引入恩了element-ui
import {
  Row,
  Col,
  Message,
  Loading,
  Menu,
  Submenu,
  MenuItem,
  Carousel,
  CarouselItem,
  Image,
  Form,
  FormItem,
  Input,
  Button,
  Card,
  Breadcrumb,
  BreadcrumbItem
} from 'element-ui'

Vue.use(Row)
Vue.use(Col)
Vue.use(Loading.directive)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Card)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service

// 按需引入ant-design
// import { Timeline } from 'ant-design-vue'
import Timeline from 'ant-design-vue/lib/timeline'
import 'ant-design-vue/lib/timeline/style/css'

Vue.use(Timeline)

// axios
// eslint-disable-next-line import/first
import { post, get, patch, put } from './utils/http'
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$patch = patch
Vue.prototype.$put = put

// 多语言
// eslint-disable-next-line import/first
import i18n from './lang'
// Vue.use(i18n)

// perfect-scrollbar
import scrollBarDir from '@/directive/scrollBar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

Vue.directive('scrollBar', scrollBarDir)

// 默认
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n: i18n.core,
  render: h => h(App)
}).$mount('#app')
